<template>
  <div class="flex flex-col gap-1">
    <div v-if="tags && tags.length" class="flex flex-wrap gap-1">
      <span v-for="(tag, i) in tags" :key="i" class="inline-flex items-center gap-1 px-2 py-0.5 bg-primary/[0.08] text-primary rounded text-xs font-medium">
        {{ tag }}
        <button type="button" class="bg-transparent border-none text-inherit cursor-pointer text-sm leading-none px-0.5 opacity-60 hover:opacity-100" @click="$emit('remove', i)">&times;</button>
      </span>
    </div>
    <input
      :value="inputValue"
      class="block w-full py-[7px] px-2 text-[13px] border border-stroke rounded-md bg-surface-light text-gray-500 outline-none transition-all duration-150 box-border"
      :placeholder="placeholder"
      @input="$emit('update:inputValue', $event.target.value)"
      @keydown.enter.prevent="$emit('add')"
    />
  </div>
</template>

<script>
export default {
  name: 'TagInput',
  props: {
    tags: { type: Array, default: () => [] },
    inputValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Type column name and press Enter' },
  },
};
</script>
